import type { Maybe } from '@backmarket/utils/types/Maybe'

import { textToSlug } from './textToSlug'

export function textToTarget(title: Maybe<string>, headingType?: string) {
  const target = textToSlug(title, headingType)

  return `scroll=false&target=${target}`
}
